import React, { useEffect, useState } from "react";
import Alert from "@material-ui/lab/Alert";
import { Slide } from "@material-ui/core";
import "./AlertBox.scss";
import useAlertBox from "./useAlertBox";

const AlertBox = ({ message = "", duration = 5000 }) => {
  const visible = useAlertBox(duration);

  return (
    <Slide direction="left" in={visible} mountOnEnter unmountOnExit>
      <Alert severity="warning" className="alert-box">
        {message}
      </Alert>
    </Slide>
  );
};

export default AlertBox;
